const HSTSCustomStyle = {
    headCells: {
      style: {
        fontWeight: "700",
        backgroundColor: "#f8f9fa",
        fontSize: "15px",
      },
    },
    cells: {
      style: {
        fontSize: "15px",
        borderRight: "1px solid #dee2e6",
      },
    },
  };
  
  export default HSTSCustomStyle;
  